<div class="main-view space-y-2 md:space-y-4">
    <app-page-surface-header titleIcon="users" title="Manage Users" [subtitle]="headingSubtitle" [tabs]="userSurfaceTabs"
        [activeTabKey]="view" tablistLabel="User list" (activeTabKeyChange)="onUserTabKey($event)" />

    <app-list-module-surface [config]="view === 'deleted' ? listSurfaceConfigDeleted : listSurfaceConfigActive"
        [filters]="listFilters" [deletedView]="view === 'deleted'" [errorMessage]="errorMessage" [loading]="isLoading"
        [meta]="meta" [rowCount]="tableData.length" (filtersChange)="onListFiltersChange($event)"
        (pageChange)="onListPageChange($event)">
        <ng-container toolbarActions>
            @if (view === 'active' && (P.USER_EXPORT | hasPermission)) {
            <button type="button"
                class="btn rounded-xl border border-gray-200 bg-white p-3 text-black shadow-none hover:bg-gray-50 disabled:opacity-50 dark:border-[#191e3a] dark:bg-[#0e1726] dark:text-white dark:hover:bg-white/5"
                [disabled]="isLoading || exporting" (click)="exportExcel()"
                title="Download Excel — all rows matching current filters">
                <icon-download class="size-5" /> &nbsp;&nbsp;
                <span> Export CSV</span>
            </button>
            }
            @if (view === 'active' && (P.USER_ADD | hasPermission)) {
            <a routerLink="/create-admin-user"
                class="btn inline-flex items-center gap-2 rounded-full border border-gray-300 bg-white px-4 py-2.5 text-sm font-medium text-black shadow-none hover:bg-gray-50 dark:border-[#191e3a] dark:bg-[#0e1726] dark:text-white dark:hover:bg-white/5">
                <icon-plus-circle class="size-5" />
                <span>Add User</span>
            </a>
            }
        </ng-container>

        <app-manage-admin-users-table listTable [rows]="tableData" [view]="view" [loading]="isLoading"
            [emptyMessage]="emptyMessage" [openActionMenuKey]="openActionMenuKey"
            (toggleMenu)="toggleActionMenu($event.key, $event.event)" (closeMenu)="closeActionMenu()"
            (viewDetail)="goToUserDetail($event)" (edit)="menuEdit($event)" (delete)="menuDelete($event)"
            (restore)="menuRestore($event)" (permanentDelete)="menuPermanentDelete($event)"
            (toggleStatus)="menuToggleStatus($event)" (resendLink)="menuResendLink($event)" />
    </app-list-module-surface>
</div>

<app-delete-confirm-modal
    [open]="showDeleteModal"
    [heading]="deleteModalHeading"
    [entityName]="selectedUser?.full_name ?? ''"
    entityNoun="user"
    [message]="deleteModalMessage"
    [variant]="deleteVariant"
    [confirmLabel]="deleteModalConfirmLabel"
    [loadingLabel]="deleteModalLoadingLabel"
    [loading]="deleteLoading()"
    [error]="deleteError"
    (cancelled)="closeDeleteModal()"
    (confirmed)="submitDelete()"
/>

<app-restore-confirm-modal [open]="showRestoreModal" heading="Restore user?"
    [entityName]="selectedUser?.full_name ?? ''" activeListLabel="active user list" [loading]="restoreLoading()"
    (cancelled)="closeRestoreModal()" (confirmed)="submitRestore()" />